import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  Root: {
    width: '100%',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  Text: {
    margin: '4px 0'
  }
}));
